/* eslint no-param-reassign: "error" */
/* eslint-disable no-new */

// *******************************************************************************
// GLOBALS
// *******************************************************************************
axios.defaults.headers['Content-Type'] = 'multipart/form-data';

// *******************************************************************************
// 0.1 - BREAKPOINT VARS
// *******************************************************************************
const breakpointSm = 767;
const breakpointMd = 1023;
const breakpointLg = 1171;

// *******************************************************************************
// 0.2 - VARIOUS FUNCTIONS
// *******************************************************************************

// Return Window Width
function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

const isFractal = () =>
  !!document.querySelector('.Frame') ||
  window.location.href.includes('localhost:3010') ||
  window.location.href.includes('/preview/components/');

const isLocal = () => window.location.href.includes('localhost');

// *******************************************************************************
// 0.3 - FUNCTIONS
// *******************************************************************************

// Attach Events
function attachEvent(selector, event, handler) {
  document.addEventListener(
    event,
    (ev) => {
      let { target } = ev;
      for (; target && target !== document; target = target.parentNode) {
        if (target.matches(selector)) {
          try {
            handler.call(target, ev);
          } catch (e) {
            console.error(e);
          }
          break;
        }
      }
    },
    false,
  );
}

const euro = Intl.NumberFormat('sl-SI', {
  style: 'currency',
  currency: 'EUR',
  useGrouping: false,
});

// Animate
function animate(elementToAnimate, type) {
  switch (type) {
    case 'show':
      elementToAnimate.classList.add('is-visible');
      elementToAnimate.classList.remove('is-hidden');
      break;
    case 'hide':
      elementToAnimate.classList.add('is-hidden');
      elementToAnimate.classList.remove('is-visible');
      break;
    default:
      break;
  }
}

// Validate email input
const validateEmailInput = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

// *******************************************************************************
// 0.4 - DEBOUNCE FUNCTION
// *******************************************************************************

function debounce(func, wait, immediate) {
  let timeout;
  return function (...args) {
    const context = this;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// *******************************************************************************
// 0.5 - SLIDE FUNCTIONS
// *******************************************************************************

const slideUp = (target, duration) => {
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.boxSizing = 'border-box';
  target.style.height = `${target.offsetHeight}px`;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = 'none';
    target.style.removeProperty('height');
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideDown = (target, duration, displayType) => {
  target.style.removeProperty('display');

  let { display } = window.getComputedStyle(target);

  if (display === 'none') {
    display = displayType;
  }
  target.style.display = display;

  target.style.display = display;
  const height = target.offsetHeight;
  target.style.overflow = 'hidden';
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  // eslint-disable-next-line no-unused-expressions
  target.offsetHeight;
  target.style.boxSizing = 'border-box';
  target.style.transitionProperty = 'height, margin, padding';
  target.style.transitionDuration = `${duration}ms`;
  target.style.height = `${height}px`;
  target.style.removeProperty('padding-top');
  target.style.removeProperty('padding-bottom');
  target.style.removeProperty('margin-top');
  target.style.removeProperty('margin-bottom');
  window.setTimeout(() => {
    target.style.removeProperty('height');
    target.style.removeProperty('overflow');
    target.style.removeProperty('transition-duration');
    target.style.removeProperty('transition-property');
  }, duration);
};

const slideToggle = (target, duration, displayType) => {
  /* Slide-toggle logic */

  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration, displayType);
  }
  return slideUp(target, duration, displayType);
};

// *******************************************************************************
// 0.7 - Smooth Scroll
// *******************************************************************************

const smoothScroll = new scrollToSmooth('a', {
  targetAttribute: 'data-scrollto',
  duration: 1000,
  durationRelative: false,
  durationMin: false,
  durationMax: false,
  easing: easeInOutCubic,
  onScrollStart: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'initial';
  },
  onScrollUpdate: (data) => {
    // do something
  },
  onScrollEnd: (data) => {
    // do something
    document.documentElement.style.scrollBehavior = 'smooth';
  },
  offset: '#custom-scroll-offset',
});
smoothScroll.init();

// *******************************************************************************
// 0.9 - Match Height / Equal height : https://dev.to/dhruvangg/equal-height-in-vanilla-javascript-49ch
// *******************************************************************************

function setHeight(el, val) {
  if (typeof val === 'function') val = val();

  if (typeof val === 'string') el.style.height = val;
  else el.style.height = `${val}px`;
}

const equalheight = function (container) {
  let currentTallest = 0;
  let currentRowStart = 0;
  const rowDivs = new Array();
  let $el;
  const topPosition = 0;

  Array.from(document.querySelectorAll(container)).forEach((el, i) => {
    el.style.height = 'auto';
    const topPostion = el.offsetTop;
    if (currentRowStart !== topPostion) {
      let currentDiv = 0;

      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        setHeight(rowDivs[currentDiv], currentTallest);
      }
      rowDivs.length = 0;
      currentRowStart = topPostion;
      currentTallest = parseFloat(getComputedStyle(el, null).height.replace('px', ''));
      rowDivs.push(el);
    } else {
      rowDivs.push(el);
      currentTallest =
        currentTallest < parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          ? parseFloat(getComputedStyle(el, null).height.replace('px', ''))
          : currentTallest;
    }

    let currentDiv = 0;
    for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
      setHeight(rowDivs[currentDiv], currentTallest);
    }
  });
};

window.addEventListener('load', () => {
  equalheight('.equal-height');
});
window.addEventListener('resize', () => {
  setTimeout(() => {
    equalheight('.equal-height');
  });
});

// *******************************************************************************
// 0.10 - ENVIRONMENT BADGE
// *******************************************************************************
const envBadge = document.querySelector('.sdt-env__badge');
if (envBadge) {
  envBadge.style.top = '150px';
  envBadge.addEventListener('mouseover', (ev) => {
    const { style } = ev.target;
    if (style.top) {
      style.removeProperty('top');
      style.bottom = '250px';
    } else {
      style.removeProperty('bottom');
      style.top = '150px';
    }
  });
}

// *******************************************************************************
// 0.11 - Get nonce for static pages
// *******************************************************************************
const getNonceForAction = async (formAction) => {
  if (isFractal()) {
    return Promise.resolve('');
  }

  try {
    const formDataNonce = {
      action: 'getNonceField',
      nonce_action: formAction,
    };

    const response = await axios.post(localData.apiURL, formDataNonce, {});
    return response.data.data.nonce;
  } catch (error) {
    console.error(error);
  }
};

// *******************************************************************************
// Email Validation Reg Exp.
// *******************************************************************************

const getEmailRegex = () => '^[^@\\s]+@([^@\\s]+\\.)+[^@\\s]+$';

const validateEmail = (value) => {
  if (value === '') {
    return true;
  }

  const emailRegex = getEmailRegex();

  return (
    FormValidation.validators.emailAddress().validate({
      value,
    }).valid &&
    FormValidation.validators.regexp().validate({
      value,
      options: {
        regexp: emailRegex,
      },
    }).valid
  );
};

// *******************************************************************************
// Form helper
// *******************************************************************************
const getEmailError = (formElement) => {
  let emailMessage = '';
  if (formElement.querySelector('[type="email"]')) {
    emailMessage = formElement.querySelector('[type="email"]').getAttribute('data-fv-email-address___message');
  }
  return emailMessage;
};

const joinActiveItems = (checkedItems) =>
  Array.from(checkedItems)
    .map((checkedItem) => checkedItem.getAttribute('value'))
    .join(' | ');

const getFormValue = (form, fv) => {
  const formData = {};
  const requiredFormData = {};

  Object.keys(fv.getFields()).forEach((key) => {
    const element = form.querySelector(`[data-fv-name="${key.replace(/\[\]/g, '')}"]`);

    if (!element) {
      return;
    }

    const parentElem = element.closest('[data-input-group-parent]');

    if ((element.type === 'radio' || element.type === 'checkbox') && parentElem) {
      const selectedInputs = parentElem.querySelectorAll('input:checked');
      const itemValues = joinActiveItems(selectedInputs);
      formData[key] = itemValues || '';

      if (element.hasAttribute('required')) {
        requiredFormData[key] = itemValues || '';
      }
    } else {
      const elementValue = fv.getElementValue(key, element);
      formData[key] = elementValue;

      if (element.hasAttribute('required')) {
        requiredFormData[key] = elementValue;
      }
    }
  });

  return { inputs: JSON.stringify(formData), requiredInputs: JSON.stringify(requiredFormData) };
};

/**
 * @typedef {Object} AxiosOptions - Options object for Axios request.
 * @property {Object} headers - Request headers.
 * @property {string} headers.Content-Type - Content type for the request.
 * @property {string} [method] - HTTP method (e.g., GET, POST, PUT, etc.).
 * @property {string} [url] - Request URL.
 * @property {Object} [params] - URL parameters.
 * @property {Object} [data] - Request payload data.
 * @property {Object} [auth] - Authentication credentials (e.g., { username: 'user', password: 'pass' }).
 * @property {number} [timeout] - Request timeout in milliseconds.
 * @property {boolean} [withCredentials] - Indicates whether cross-site Access-Control requests
 *                                         should be made using credentials.
 */

/**
 * @typedef {Object} Options - Options object for the onFormSubmit function.
 * @property {AxiosOptions} [axiosOptions] - Options for the Axios request.
 * @property {Object} formData - The form data to submit.
 * @property {string} [recaptchaKey] - Recaptcha key.
 * @property {string} [recaptchaAction] - Recaptcha action.
 * @property {number} [timeout] - Timeout for the request in milliseconds.
 * @property {string} [url] - Url of the request.
 * @property {boolean} [forceError] - You should use this to force an form error, to test UI on error.
 */

/**
 * Simulates a form submission using Axios.
 * @param {Options} [options] - Additional options for the request.
 * @returns {Promise} - A promise that resolves to the Axios response.
 */

const onFormSubmit = async (options = { formData: {} }) => {
  // Default values
  if (!options.formData.lang) {
    options.formData.lang = localData.lang;
  }

  // FE / Preview submission of the form without API
  if (isFractal()) {
    console.warn('Fractal - Simulating request');
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (options.forceError) {
          reject(new Error('Simulated error'));
          return;
        }

        console.warn('Simulated success, FormData:', options.formData);
        resolve();
      }, options.timeout || 250);
    });
  }

  if (options.recaptchaKey && options.recaptchaAction) {
    const token = await grecaptcha.execute(options.recaptchaKey, { action: options.recaptchaAction });
    const nonce = await getNonceForAction(options.recaptchaAction);

    options.formData = { ...options.formData, action: options.recaptchaAction, nonce, token };
  }

  // Make a request to the API
  return axios.post(options.url || localData.siteURL, options.formData, {
    ...options.axiosOptions,
  });
};

// *******************************************************************************
// Add scrollbar width
// *******************************************************************************

let scrollbarSize = 0;
const getScrollbarWidth = () => {
  const outer = document.createElement('div');
  outer.style.visibility = 'hidden';
  outer.style.overflow = 'scroll'; // forcing scrollbar to appear
  outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
  document.body.appendChild(outer);
  const inner = document.createElement('div');
  outer.appendChild(inner);
  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
  scrollbarSize = scrollbarWidth;
  outer.parentNode.removeChild(outer);
  document.documentElement.style.setProperty('--scroll-width', `${scrollbarWidth}px`);
};

getScrollbarWidth();

window.addEventListener('resize', () => {
  getScrollbarWidth();
});

// *******************************************************************************
// Toggle class functions
// *******************************************************************************
const toggleBodyScrollLock = (toggle) => {
  const drawerEle = document.querySelector('[data-drawer].is-open');
  if (drawerEle) return;
  document.body.classList.toggle('body-scroll-locked', toggle);
  document.body.classList.toggle('show-bottom-bar', toggle);
};

// *******************************************************************************
// "Edit mode" on front - scroll into view
// *******************************************************************************
document.addEventListener('DOMContentLoaded', () => {
  const editButton = document.getElementById('wp-admin-bar-add-edit-mode-on');
  if (!editButton) {
    return;
  }
  const checkbox = editButton.querySelector('input');
  editButton.addEventListener('click', (e) => {
    e.preventDefault();
    checkbox.checked = !checkbox.checked;
    if (!checkbox.checked) {
      e.target.blur();
    }
    editButton.classList.toggle('is-active', checkbox.checked);
    document.querySelectorAll('main section').forEach((section, index) => {
      section.classList.toggle('editable-section', checkbox.checked);
      section.addEventListener(
        'click',
        (e) => {
          e.preventDefault();
          if (checkbox.checked) {
            e.stopPropagation();
            window.location.replace(`/wp-admin/post.php?post=${localData.id}&action=edit&module-section=${index}`);
          }
        },
        { once: true },
      );
    });
  });

  const params = new URLSearchParams(window.location.search);
  const targetIndex = parseInt(params.get('module-section'), 10);
  if (!isNaN(targetIndex)) {
    const sections = document.querySelectorAll('main section');
    const index = targetIndex;
    if (sections[index]) {
      setTimeout(() => {
        sections[index].scrollIntoView({
          behavior: 'smooth',
        });
        params.delete('module-section');
        window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
      }, 500);
    }
  }
});

// *******************************************************************************
// Toggle Classes
// *******************************************************************************

const removeActiveClass = (elements) => {
  elements.forEach((el) => el.classList.remove('is-active'));
};

// Toggle product cols
const toggleHideClass = (element, toggle) => {
  element.classList.toggle('hide', toggle);
};

// *******************************************************************************
// Tabs
// *******************************************************************************

const tabLinks = document.querySelectorAll('[data-tab-link]');

const activateTabById = (targetId) => {
  const link = document.querySelector(`[data-tab-link][data-tab-id="${targetId}"]`);

  if (!link) return;

  const tab = link.closest('[data-tab]');
  const linksParent = link.closest('[data-tab-links]');
  const targetTabContent = tab?.querySelector(`[data-tab-content][id="${targetId}"]`);
  if (!tab || !linksParent || !targetTabContent) return;

  // Remove all active classes
  removeActiveClass(linksParent.querySelectorAll('[data-tab-link]'));
  removeActiveClass(tab.querySelectorAll('[data-tab-content]'));

  // Add active classes
  link.classList.add('is-active');
  targetTabContent.classList.add('is-active');
};

const handleTabClick = (e) => {
  const link = e.currentTarget;

  // With and Without [data-tab-id]
  const tab = link.closest('[data-tab]') || link.closest('[data-tab-links]');
  const allTabLinks = Array.from(tab.querySelectorAll('[data-tab-link]'));
  const allTabContents = Array.from(tab.querySelectorAll('[data-tab-content]'));
  const targetId = link.getAttribute('data-tab-id');

  if (!targetId) {
    const index = allTabLinks.indexOf(link);
    const targetContent = allTabContents[index];
    removeActiveClass(allTabLinks);
    link.classList.add('is-active');

    if (!targetContent) return;

    removeActiveClass(allTabContents);
    targetContent.classList.add('is-active');
    return;
  }

  e.preventDefault();
  activateTabById(targetId);
};

tabLinks.forEach((link) => {
  link.addEventListener('click', handleTabClick);
});

// *******************************************************************************
// Toggle class on scroll
// *******************************************************************************
const menuButtons = document.querySelectorAll('.menu__buttons-item');
const homepageHeader = document.querySelector('.header-main--homepage');
const firstMenuButton = document.querySelector('.menu__buttons-item');

const initScrollClasses = () => {
  if (!menuButtons.length || !firstMenuButton) return;

  let lastScrollTop = 0;
  let ticking = false;
  let scrollUpTimer = null;

  const SCROLLED_THRESHOLD = 150;
  const SCROLL_UP_DELAY = 10;

  const updateClasses = (scrollY) => {
    const isScrollingDown = scrollY > lastScrollTop;
    const isScrollingUp = scrollY < lastScrollTop;

    // Toggle general scroll class
    const isScrolled = scrollY > SCROLLED_THRESHOLD;
    document.body.classList.toggle('is-scrolled', isScrolled);

    // Scroll up/down classes with delay
    if (isScrollingUp) {
      clearTimeout(scrollUpTimer);
      scrollUpTimer = setTimeout(() => {
        document.body.classList.add('is-scrolled-up');
      }, SCROLL_UP_DELAY);
    } else if (isScrollingDown) {
      clearTimeout(scrollUpTimer);
      document.body.classList.remove('is-scrolled-up');
    }

    lastScrollTop = Math.max(scrollY, 0);

    // Menu state
    if (isScrolled) {
      menuButtons.forEach((btn) => btn.classList.remove('is-active'));
    } else if (homepageHeader) {
      firstMenuButton.classList.add('is-active');
    }
  };

  // Native scroll listener (mobile & fallback)
  const onScroll = () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateClasses(window.scrollY || 0);
        ticking = false;
      });
      ticking = true;
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  updateClasses(window.scrollY || 0);
};

initScrollClasses();

// *******************************************************************************
// Menu
// *******************************************************************************

const updateFirstActive = () => {
  const isScrolled = document.body.classList.contains('is-scrolled');
  if (homepageHeader && !isScrolled) {
    firstMenuButton.classList.add('is-active');
  }
};

// Set initial active
updateFirstActive();

const clearActiveMenu = () => removeActiveClass(menuButtons);

// *******************************************************************************
// Set header height css variable
// *******************************************************************************

let resizeRaf;

const updateHeights = () => {
  const header = document.querySelector('.header-main');
  const infoBar = document.querySelector('.info-bar');
  const subMenu = document.querySelector('.menu-slider__white-bg');

  const root = document.documentElement;
  root.style.setProperty('--header-height', `${header?.offsetHeight || 0}px`);
  root.style.setProperty('--sub-menu-height', `${subMenu?.offsetHeight || 0}px`);

  // if (Cookies.get('info_bar_accepted')) {
  //   root.style.setProperty('--top-bar-height', '0px');
  // } else {
  //   root.style.setProperty('--top-bar-height', `${infoBar?.offsetHeight || 0}px`);
  // }

  root.style.setProperty('--top-bar-height', `${infoBar?.offsetHeight || 0}px`);

  // Filter Footer
  const filterFooter = document.querySelectorAll('.product-filter__footer');
  filterFooter.forEach((ele) => {
    const parentEle = ele.closest('[data-filter-footer]');
    parentEle?.style.setProperty('--filter-footer-height', `${ele?.offsetHeight || 0}px`);
  });
};

const onResize = () => {
  cancelAnimationFrame(resizeRaf);
  resizeRaf = requestAnimationFrame(updateHeights);
};

updateHeights();
window.addEventListener('resize', onResize);

// *******************************************************************************
// KeyDown Function
// *******************************************************************************

const onKeydown = (key, callback) => {
  document.addEventListener('keydown', (event) => {
    if (event.key.toLowerCase() === key.toLowerCase()) {
      callback(event);
    }
  });
};

// *******************************************************************************
// Scroll function
// *******************************************************************************

const scrollTop = (element) => {
  const scrollPosition = element.getBoundingClientRect().top + window.scrollY;

  window.scrollTo({
    top: scrollPosition - getHeaderHeight(),
    behavior: 'smooth',
  });
};

// *******************************************************************************
// Stretch items until left or right of screen
// *******************************************************************************
const stretchElements = () => {
  const scrollbarSize = window.innerWidth - document.documentElement.clientWidth;

  // Stretch to the right edge of the screen
  document.querySelectorAll('[data-stretch-right]').forEach((el) => {
    const rect = el.getBoundingClientRect();
    const distance = window.innerWidth - rect.left - scrollbarSize;
    el.style.setProperty('--right-distance', `${distance}px`);
  });

  // Stretch to the left edge of the screen
  document.querySelectorAll('[data-stretch-left]').forEach((el) => {
    const rect = el.getBoundingClientRect();
    const distance = rect.right;
    el.style.setProperty('--left-distance', `${distance}px`);
  });
};

stretchElements();
window.addEventListener('resize', stretchElements);

// *******************************************************************************
// Detect touch devices
// *******************************************************************************
const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

// *******************************************************************************
// Custom Scrollbar For Module
// *******************************************************************************

const enableScrollbarSync = (parent, scrollbarEle) => {
  const swiperWrapper = parent.querySelector('.swiper');
  const swiperInner = parent.querySelector('.swiper-wrapper');
  const scrollbar = scrollbarEle || parent.querySelector('.swiper-scrollbar');

  if (!swiperWrapper || !swiperInner || !scrollbar) return;

  scrollbar.innerHTML = '<div class="swiper-scrollbar-thumb"></div>';
  const scrollbarThumb = scrollbar.querySelector('.swiper-scrollbar-thumb');

  let startX;
  let startThumbLeft;

  const onTouchMove = (event) => {
    const deltaX = event.touches[0].clientX - startX;
    const maxThumbMove = scrollbar.clientWidth - scrollbarThumb.clientWidth;
    const newLeft = Math.min(Math.max(startThumbLeft + deltaX, 0), maxThumbMove);

    const scrollPercentage = newLeft / maxThumbMove;
    swiperWrapper.scrollLeft = scrollPercentage * (swiperWrapper.scrollWidth - swiperWrapper.clientWidth);
  };

  const onTouchEnd = () => {
    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
  };

  const onTouchStart = (event) => {
    startX = event.touches[0].clientX;
    startThumbLeft = scrollbarThumb.offsetLeft;

    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
  };

  const syncThumbToScroll = () => {
    const maxThumbMove = scrollbar.clientWidth - scrollbarThumb.clientWidth;
    const maxScroll = swiperWrapper.scrollWidth - swiperWrapper.clientWidth;
    const percentage = swiperWrapper.scrollLeft / maxScroll;
    scrollbarThumb.style.left = `${percentage * maxThumbMove}px`;
  };

  scrollbarThumb.addEventListener('touchstart', onTouchStart);
  swiperWrapper.addEventListener('scroll', syncThumbToScroll);

  // Hide scrollbar if no overflow
  const slideCount = swiperInner.children.length;
  scrollbar.classList.toggle('hide', slideCount <= 1);

  // Cleanup function (call when switching back to desktop)
  // eslint-disable-next-line consistent-return
  return () => {
    scrollbarThumb.removeEventListener('touchstart', onTouchStart);
    swiperWrapper.removeEventListener('scroll', syncThumbToScroll);
  };
};

const setupResponsiveSliders = ({
  sliderElements,
  breakpoint = 767,
  initSlider,
  mobileFallback,
  parentSelector = '[data-slider-parent]',
  debounceDelay = 150,
}) => {
  const handleSlider = () => {
    sliderElements.forEach((sliderEl) => {
      const parent = sliderEl.closest(parentSelector);
      const isDesktop = windowWidth() > breakpoint;

      if (isDesktop) {
        if (!sliderEl.swiper) {
          initSlider(sliderEl);
          sliderEl.swiper.update();
        }
      } else {
        mobileFallback(parent);

        if (sliderEl.swiper) {
          sliderEl.swiper.destroy(true, true);
          sliderEl.swiper = null;
        }
      }
    });
  };

  // Initial run
  handleSlider();

  // Debounced resize
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleSlider, debounceDelay);
  });
};

// *******************************************************************************
// Active Indicator Movement
// *******************************************************************************
const updateActiveIndicator = () => {
  document.querySelectorAll('.active-indicator').forEach((indicator) => {
    const wrapper = indicator.closest('[data-indicator-wrapper]');
    if (!wrapper) return;

    const slides = wrapper.querySelectorAll('[data-indicator-item]');

    const updateIndicator = () => {
      const activeSlide = wrapper.querySelector('.is-active');
      if (!activeSlide) return;

      const { left, top, width, height } = activeSlide.getBoundingClientRect();
      const { left: wrapperLeft, top: wrapperTop } = wrapper.getBoundingClientRect();

      if (width === 0 || height === 0) return; // ignore hidden state

      indicator.style.width = `${width}px`;
      indicator.style.height = `${height}px`;
      indicator.style.transform = `translate(${left - wrapperLeft}px, ${top - wrapperTop}px)`;
    };

    wrapper.addEventListener('click', (e) => {
      const slide = e.target.closest('[data-indicator-item]');
      if (!slide) return;

      slides.forEach((s) => s.classList.remove('is-active'));
      slide.classList.add('is-active');

      updateIndicator();
    });

    const handleIndicatorResize = debounce(updateIndicator, 100);
    window.addEventListener('resize', handleIndicatorResize);

    // Initial alignment
    updateIndicator();
  });
};

window.addEventListener('DOMContentLoaded', updateActiveIndicator);

// *******************************************************************************
// Dropdown Counter
// *******************************************************************************

const countSelected = (dropdown) => {
  const countEle = dropdown.querySelector('.dropdown__count');

  const selectedOptions = [...dropdown.querySelectorAll('.dropdown__list-inner input:checked')].map((input) =>
    input.nextElementSibling.textContent.trim(),
  );

  const totalCount = selectedOptions.length;

  countEle.classList.toggle('hide', totalCount === 0);
  countEle.textContent = totalCount;

  if (!dropdown.classList.contains('dropdown-accordion')) {
    if (totalCount === 0) dropdown.classList.remove('is-open');
    dropdown.classList.toggle('is-selected', totalCount > 0);
  }

  // Mobile Counter For Filter
  const filterEle = dropdown.closest('.product-filter__inner');
  if (windowWidth() < breakpointMd && filterEle) {
    const targetEle = dropdown.getAttribute('data-dropdown');
    const targetButtonEle = filterEle?.querySelector(`[data-target-dropdown="${targetEle}"]`);
    const targetCounter = targetButtonEle.querySelector('.product-filter__button-count');
    targetCounter.classList.toggle('hide', totalCount === 0);
    targetCounter.textContent = totalCount;
  }
};

// *******************************************************************************
// Input Focus
// *******************************************************************************
const addFocusClass = (ev, toggle) => {
  const parent = ev.target.closest('.add-promo-code__input-wrapper');
  parent.classList.toggle('is-focused', toggle);
};

const inputFocus = () => {
  const inputFields = document.querySelectorAll('.add-promo-code .add-promo-code__input');
  inputFields.forEach((inputField) => {
    inputField.addEventListener('focus', (ev) => addFocusClass(ev, true));

    inputField.addEventListener('blur', (ev) => {
      if (!inputField.value) addFocusClass(ev, false);
    });
  });
};

// *******************************************************************************
// Update Cart on change
// *******************************************************************************
const updateCartOnChange = (data, source) => {
  if (source === 'popup') {
    document.querySelector('.cart-popup .cart-popup__content').innerHTML = data;
  } else if (source === 'cartPage') {
    document.querySelector('.cart-module .cart-module__inner').innerHTML = data;
  }

  checkProgressWidth();
};

// *******************************************************************************
// Prevent emoji text
// *******************************************************************************

const noEmojiInputs = document.querySelectorAll('[data-no-emoji]');

// Emoji detection regex (broad, compatible version)
const emojiRegex = /([\u203C-\u3299]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\uD83E[\uDD00-\uDDFF])/g;

noEmojiInputs.forEach((input) => {
  const removeEmojis = () => {
    const oldValue = input.value;
    const newValue = oldValue.replace(emojiRegex, '');
    if (oldValue !== newValue) {
      input.value = newValue;
    }
  };

  // Block typing emojis
  input.addEventListener('keypress', (e) => {
    if (emojiRegex.test(e.key)) {
      e.preventDefault();
    }
  });

  // Clean pasted or auto-filled text
  input.addEventListener('input', removeEmojis);
  input.addEventListener('paste', (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    input.value += pasted.replace(emojiRegex, '');
  });
});

// *******************************************************************************
// Embedded Video
// *******************************************************************************

const embeddedVideoInit = (trigger, parent, initContainer) => {
  attachEvent(trigger, 'click', (ev) => {
    let player;
    const number = Math.floor(Math.random() * 10000 + 1);
    const parentElement = ev.target.closest(parent);
    const videoURL = parentElement.getAttribute('data-id');
    const videoID = `id_${number}`;

    // Add class to parentElement for hiding poster
    parentElement.classList.add('is-playing');

    // Set the div ID to match API player ID
    parentElement.querySelector(initContainer).id = videoID;

    // API EVENT: Play
    const onPlayerReady = (event) => {
      event.target.playVideo();
    };

    // API EVENT: Check for ending
    const onPlayerStateChange = (event) => {
      if (event.data === 0) {
        // Stop and destroy player (stops video and removes player instance and iframe)
        parentElement.classList.remove('is-playing');
        player.stopVideo();
        player.destroy();
        player = null;
      }
    };

    // API: Create new player
    player = new YT.Player(videoID, {
      // Set the api ID to match div ID
      videoId: videoURL,
      events: {
        onReady: onPlayerReady,
        onStateChange: onPlayerStateChange,
      },
    });
  });
};

const resetYT = (parent) => {
  const youtubeContainer = parent.querySelectorAll('.embeded-video__iframe');
  youtubeContainer.forEach((container) => {
    const parentEle = container.closest('.embeded-video__wrapper');
    parentEle.classList.remove('is-playing');
    container.innerHTML = '<div class="embeded-video__iframe-container" data-youtube-container></div>';
  });
};

// *******************************************************************************
// Common Modal Toggle
// *******************************************************************************

const toggleModal = (element, toggle) => {
  const parentElement = element.closest('[data-modal-parent]');
  const parentId = element.closest('[data-id]')?.getAttribute('data-id');
  const modal = parentElement?.querySelector(`[data-modal]${parentId ? `[data-id="${parentId}"]` : ''}`);
  modal?.classList.toggle('is-open-modal', toggle);
  document.body.classList.toggle('modal-open', toggle);

  toggleBodyScrollLock(toggle);

  // Reset Youtube
  resetYT(parentElement);
};

// Close modal on Escape key
onKeydown('escape', () => {
  document.querySelectorAll('[data-modal].is-open-modal:not(:has([data-drawer].is-open))').forEach((ev) => {
    toggleModal(ev, false);
  });
});

// *******************************************************************************
// Page load class
// *******************************************************************************
window.addEventListener('load', () => {
  document.body.classList.add('page-loaded');
});

// *******************************************************************************
// Dropdown Global click handler
// *******************************************************************************

// --- Utility functions ---
const updateSingleSelect = (dropdown, option) => {
  dropdown.classList.remove('is-open');
  dropdown.classList.add('is-selected');
  const filterEle = dropdown.closest('.product-filter');
  if (filterEle) {
    countSelected(dropdown);
    return;
  }
  const placeholderText = dropdown.querySelector('.dropdown__placeholder-text');
  placeholderText.textContent = option.textContent.trim();
  placeholderText.dataset.ehrm = option.dataset.ehrm || '';
};

// Add the click listener only once
let dropdownHandlerInitialized = false;

const dropdownGlobalHandler = () => {
  if (dropdownHandlerInitialized) return;
  dropdownHandlerInitialized = true;

  document.addEventListener('click', (event) => {
    const dropdown = event.target.closest('.dropdown');
    const allDropdown = document.querySelectorAll('.dropdown');

    // Close all others
    allDropdown.forEach((d) => {
      if (d !== dropdown) {
        if (!d.classList.contains('dropdown-accordion')) d.classList.remove('is-open');
        d.querySelector('.dropdown__search-input')?.blur();
      }
    });

    if (!dropdown) return;

    // Toggle open
    if (event.target.closest('.dropdown__placeholder')) {
      dropdown.classList.toggle('is-open');
      dropdown.querySelector('.dropdown__search-input')?.focus();
      return;
    }

    // Handle single-select option click
    const option = event.target.closest('.dropdown__list-option');
    if (option && !dropdown.classList.contains('dropdown--multiselect')) {
      updateSingleSelect(dropdown, option);
    }
  });
};

// *******************************************************************************
// Price Number Animation
// *******************************************************************************

const prevFormattedMap = new WeakMap();
const prevCurrencyMap = new WeakMap();

const extractCurrency = (raw) => {
  if (!raw) return '';
  const text = String(raw).trim();
  const match = text.match(/[^\d.,]/g);
  if (!match) return '';
  return match.join('').replace(/\s+/g, '');
};

const parseEU = (raw) => {
  if (!raw) return 0;
  let str = String(raw);
  str = str.replace(/[^\d.,]/g, '');
  str = str.replace(/\./g, '');
  str = str.replace(',', '.');
  const num = parseFloat(str);
  return isNaN(num) ? 0 : num;
};

const formatEU = (num, currency) => {
  const intPart = Math.floor(num);
  const decPart = Math.round((num - intPart) * 100);

  const intStr = intPart.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

  const decStr = `00${decPart}`.slice(-2);

  return currency ? `${intStr},${decStr} ${currency}` : `${intStr},${decStr}`;
};

const updateWidthAfterAnimation = (container) => {
  const activeDigit = container.querySelector('.animated-price-wheel-item-active');
  if (!activeDigit) return;

  const { width } = activeDigit.getBoundingClientRect();
  const rounded = Math.ceil(width);

  container.style.setProperty('--digit-width', `${rounded + 1}px`);
};

const updateOdometer = (el, rawValue, currentValue, forceAsCurrent = false) => {
  const parent = el.closest('[data-animated-price-parent]');
  const isNormal = parent?.hasAttribute('data-animated-price-normal');

  const currency = extractCurrency(rawValue) || prevCurrencyMap.get(el) || '';
  prevCurrencyMap.set(el, currency);

  const num = parseEU(rawValue);
  const formatted = isNormal ? String(num) : formatEU(num, currency);
  const oldFormatted = forceAsCurrent ? currentValue : prevFormattedMap.get(el) || '';

  el.innerHTML = '';

  const maxLen = formatted.length;
  const oldLen = oldFormatted.length;

  // Build characters from RIGHT to LEFT
  for (let i = 0; i < maxLen; i++) {
    const newChar = formatted[maxLen - 1 - i];
    const oldChar = oldFormatted[oldLen - 1 - i] ?? null;

    const wrapper = document.createElement('div');

    if (/\d/.test(newChar)) {
      wrapper.className = 'animated-price-char';

      const wheel = document.createElement('div');
      wheel.className = 'animated-price-wheel';
      const digitEls = [];

      // Build digits 0–9
      for (let d = 0; d <= 9; d++) {
        const div = document.createElement('div');
        div.className = 'animated-price-wheel-item';
        if (d === +newChar) div.classList.add('animated-price-wheel-item-active');
        div.textContent = d;
        wheel.appendChild(div);
        digitEls.push(div);
      }

      wrapper.appendChild(wheel);

      // Start digit (from previous)
      const startDigit = /\d/.test(oldChar) ? Number(oldChar) : 0;
      wheel.style.transition = 'none';
      wheel.style.transform = `translateY(-${startDigit}em)`;

      // eslint-disable-next-line no-loop-func
      requestAnimationFrame(() => {
        const digitHeight = digitEls[0].getBoundingClientRect().height;

        digitEls.forEach((elem, index) => {
          elem.style.top = `${digitHeight * index}px`;
        });

        // Animate to new digit
        requestAnimationFrame(() => {
          wheel.style.transition = 'transform 300ms ease';
          wheel.style.transform = `translateY(-${Number(newChar)}em)`;
        });
      });
    } else {
      // Static characters (comma/dot)
      wrapper.className = 'animated-price-static-char';
      wrapper.textContent = newChar;
    }

    el.prepend(wrapper);
    if (wrapper) updateWidthAfterAnimation(wrapper);
  }

  prevFormattedMap.set(el, formatted);
};

// Init Render New HTML
const initOdometerForElement = (parent, currentValue) => {
  const inputEle = parent.querySelector('[data-animated-price-input]');
  const priceEle = parent.querySelector('[data-animated-price]');
  if (!inputEle || !priceEle) return;

  const defaultValue = inputEle?.getAttribute('value') ?? inputEle?.value ?? '0';
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      updateOdometer(priceEle, defaultValue, currentValue, true);
    });
  });
};

// Init
const priceAnimate = document.querySelectorAll('[data-animated-price-parent]');
priceAnimate.forEach((ele) => {
  const inputEle = ele.querySelector('[data-animated-price-input]');
  const priceEle = ele.querySelector('[data-animated-price]');
  // For Page Load Animation
  // const defaultValue = inputEle.value || 0;
  // updateOdometer(priceEle, defaultValue);

  const inputObserver = new MutationObserver(() => {
    const newVal = inputEle.getAttribute('value');
    updateOdometer(priceEle, newVal);
  });

  inputObserver.observe(inputEle, {
    attributes: true,
    attributeFilter: ['value'],
  });

  inputEle.addEventListener('input', (ev) => {
    const { value } = ev.target;
    inputEle.setAttribute('value', value);
  });
});

// eslint-disable-next-line no-unused-vars
const animateNumbersValue = (currentValue, selector = '') => {
  let valueAll = document.querySelectorAll('.cart-module__amount-row--total');
  if (valueAll.length === 0) {
    valueAll = document.querySelectorAll('.cart-popup__content .cart-popup__total');
  }
  if (selector) {
    valueAll = document.querySelectorAll(selector);
  }
  valueAll.forEach((item) => {
    initOdometerForElement(item, currentValue);
  });
};

// **********************************************************
// Latest Product Animation
// **********************************************************
const animateLatestCart = debounce(() => {
  const cartPopupInner = document.querySelector('.cart-popup__inner');
  if (!cartPopupInner) return;

  const io = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        const el = entry.target;
        if (!entry.isIntersecting) return;
        if (!el.classList.contains('is-new-added')) return;
        if (el.classList.contains('animation-done')) return;

        el.classList.add('animation-done');
        el.classList.remove('is-start-animation');

        setTimeout(() => {
          el.classList.add('is-start-animation');
        }, 300);

        setTimeout(() => {
          el.classList.remove('is-start-animation');
          el.classList.remove('is-new-added');
        }, 1500);

        observer.unobserve(el);
      });
    },
    {
      root: cartPopupInner,
      threshold: 0.65,
    },
  );

  const observeItemClassChanges = (item) => {
    io.observe(item);

    const mutationObserver = new MutationObserver(() => {
      if (item.classList.contains('is-new-added')) {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
      if (item.classList.contains('animation-done')) {
        mutationObserver.disconnect();
      }
    });

    mutationObserver.observe(item, {
      attributes: true,
      attributeFilter: ['class'],
    });
  };
  cartPopupInner.querySelectorAll('.cart-view__item').forEach(observeItemClassChanges);
}, 100);
